// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + "66106e423e2fd25ef416" + ".css";
};